module.exports = __webpack_public_path__ + "img/HENRIQUE.1f80145f.jpeg";